import { useNavigate } from "react-router-dom";
import LoginForm from "./login-form";
import { XIcon } from "lucide-react";

interface LoginModalProps {
  open: boolean;
  onClose: () => void;
  onSuccess?: () => void;
}

const LoginModal: React.FC<LoginModalProps> = ({ open, onClose }) => {
  const navigate = useNavigate()
  if (!open) return null;


  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className=" rounded-xl w-[500px] p-6 relative">
        <button
          onClick={onClose}
          className="absolute top-10 right-4 text-gray-500"
        >
          <XIcon />
        </button>

        <LoginForm
          isModal
          onSuccess={() => {
            const userType = localStorage.getItem("user-type");

            onClose();

            switch (userType) {
              case "SUPER_ADMIN":
                navigate("/admin/overview", { replace: true });
                break;

              case "ADVERTISER":
                navigate("/business/profile", { replace: true });
                break;

              case "RECOMMENDER":
              default:
                navigate("/", { replace: true });
                break;
            }
          }}

        />

      </div>
    </div>
  );
};

export default LoginModal;
